const AUTH_TOKEN_STORAGE_KEY = 'sellyt_auth_token';

export const getAuthToken = (): string | null => {
  try {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    return token?.trim() ? token.trim() : null;
  } catch {
    return null;
  }
};

/** Headers for authenticated requests to the Sellyt API. */
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const setAuthToken = (token: string): void => {
  try {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token.trim());
  } catch {
    // Ignore storage failures (private browsing, quota, etc.).
  }
};

export const clearAuthToken = (): void => {
  try {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
};

export const hasAuthToken = (): boolean => Boolean(getAuthToken());

/** Reads `userId` from the JWT payload when present. */
export const getUserIdFromAuthToken = (): number | undefined => {
  const token = getAuthToken();
  if (!token) return undefined;

  try {
    const [, payload] = token.split('.');
    if (!payload) return undefined;

    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      '='
    );
    const parsed = JSON.parse(atob(padded)) as { userId?: unknown };
    return typeof parsed.userId === 'number' ? parsed.userId : undefined;
  } catch {
    return undefined;
  }
};
